import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TooltipConstants {
  public CLEAR_BUTTON: string = "Clear search";
  public CLOSE_BUTTON: string = "Close";
  public COLLAPSE_TASKS: string = "Hide tasks";
  public COLLAPSE_COURSES: string = "Hide courses";
  public COLLAPSE_DETAILS: string = "Hide details";
  public COLLAPSE_DOCUMENTS: string = "Hide documents";
  public COLLAPSE_MAPPED_DETAILS: string = "Hide mapped positions";
  public COLLAPSE_PERMISSIONS: string = "Hide permissions";
  public COLLAPSE_RESPONDER_AVAILABILITIES: string = "Hide all responder availabilities";
  public COLLAPSE_ROLES: string = "Hide roles";
  public COLLAPSE_STEPS: string = "Hide steps";

  public EXPAND_TASKS: string = "Show tasks";
  public EXPAND_COURSES: string = "Show courses";
  public EXPAND_DETAILS: string = "Show details";
  public EXPAND_DOCUMENTS: string = "Show documents";
  public EXPAND_MAPPED_DETAILS: string = "Show mapped positions";
  public EXPAND_PERMISSIONS: string = "Show permissions";
  public EXPAND_RESPONDER_AVAILABILITIES: string = "Show all responder availabilities";
  public EXPAND_ROLES: string = "Show roles";
  public EXPAND_STEPS: string = "Show steps";
}
